import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ScientificCredibilityBanner } from './components/ScientificCredibilityBanner';
import { TransformationQuestionnaire } from './components/TransformationQuestionnaire';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { PortalSelection } from './components/PortalSelection';
import { SuperhumanPage } from './components/SuperhumanPage';
import { Footer } from './components/Footer';
export function App() {
  const [selectedPortal, setSelectedPortal] = useState<'health' | 'superhuman' | null>(null);
  const [pendingScroll, setPendingScroll] = useState<string | null>(null);
  useEffect(() => {
    if (selectedPortal === 'health' && pendingScroll) {
      setTimeout(() => {
        const element = document.getElementById(pendingScroll);
        element?.scrollIntoView({
          behavior: 'smooth'
        });
        setPendingScroll(null);
      }, 100);
    }
  }, [selectedPortal, pendingScroll]);
  const handleNavigation = (sectionId: string) => {
    if (selectedPortal === 'health') {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      setSelectedPortal('health');
      setPendingScroll(sectionId);
    }
  };
  if (selectedPortal === 'superhuman') {
    return <SuperhumanPage data-id="element-0" />;
  }
  if (selectedPortal === 'health') {
    return <div className="min-h-screen bg-gradient-to-br from-slate-900 via-fuchsia-950 to-cyan-950 flex flex-col" data-id="element-1">
        <Header onNavigate={handleNavigation} data-id="element-2" />
        <HeroSection onNavigate={handleNavigation} data-id="element-3" />
        <ScientificCredibilityBanner onNavigate={handleNavigation} data-id="element-4" />
        <CaseStudiesSection onNavigate={handleNavigation} data-id="element-5" />
        <TransformationQuestionnaire data-id="element-6" />
        <Footer data-id="element-7" />
      </div>;
  }
  return <PortalSelection onSelectPortal={setSelectedPortal} onNavigate={handleNavigation} data-id="element-8" />;
}